var initializeTestimonialCarouselBlock = function(block){

	setupHorizontalDragging(block);
	
	var slider = jQuery('.slider', block);
	var sliderCount = jQuery('> .slide', slider).length;
	var slideMargin = 15;
	var slideWidth = jQuery('> .slide:eq(0)', slider).outerWidth() + slideMargin;
	var sliderWidth = slideWidth * sliderCount;
	var screenWidth = jQuery(window).width();
	var offset = sliderCount > 2 ? (slideWidth*1.5 - screenWidth/2) + slideMargin : 0;
	
	jQuery('.slider', block).scrollLeft(offset);

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-testimonial-carousel').each(function(){
		initializeTestimonialCarouselBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=testimonial-carousel', initializeTestimonialCarouselBlock);


function setupHorizontalDragging(block){
	
	const slider = jQuery('.slider:not(.setup)', block)[0];
	
	if(!slider) return false;
	
	let isDown = false;
	let startX;
	let scrollLeft;
	
	slider.addEventListener("mousedown", e => {
		isDown = true;
		slider.classList.add("dragging");
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	});
	
	slider.addEventListener("mouseleave", () => {
		isDown = false;
		slider.classList.remove("dragging");
	});
	
	slider.addEventListener("mouseup", () => {
		isDown = false;
		slider.classList.remove("dragging");
	});
	
	slider.addEventListener("mousemove", e => {
		
		if (!isDown) return;
		
		e.preventDefault();
		
		const x = e.pageX - slider.offsetLeft;
		const walk = x - startX;
		
		slider.scrollLeft = scrollLeft - walk;
		
	});
	
	slider.classList.add("set-up");
	
}